import { useDispatch } from "react-redux";
import * as TH from "./thunkCreators";

export const useStartImpersonationCallback = () => {
  const dispatch = useDispatch();
  return (userId: number) => dispatch(TH.impersonate({ userId }));
};

export const useIsImpersonatingCallback = () => {
  const dispatch = useDispatch();
  return () => dispatch(TH.isImpersonating());
};

export const useStopImpersonatingCallback = () => {
  const dispatch = useDispatch();
  return () => dispatch(TH.stopImpersonating());
};
